import { Navigate, Route, Routes } from 'react-router';
import { GardeModule } from './auth/GardeModule';
import { RequireAuth } from './auth/RequireAuth';
import { AppShell } from './components/layout/AppShell';
import { Budget } from './pages/Budget';
import { BudgetVersions } from './pages/BudgetVersions';
import { Connexion } from './pages/Connexion';
import { MotDePasse } from './pages/MotDePasse';
import { Notifications } from './pages/Notifications';
import { PlanMensuel } from './pages/PlanMensuel';
import { PlanFiche } from './pages/plan/PlanFiche';
import { PlanListe } from './pages/plan/PlanListe';
import { CommentairesCloture } from './pages/CommentairesCloture';
import { Rapports } from './pages/Rapports';
import { Ressources } from './pages/Ressources';
import { TableauDeBord } from './pages/TableauDeBord';
import { MesDemarches } from './pages/rh/MesDemarches';
import { AgentsRh } from './pages/rh/AgentsRh';
import { FicheRhPage } from './pages/rh/FicheRh';
import { DossierHrmsPage } from './pages/rh/DossierHrms';
import { GestionHrms } from './pages/rh/GestionHrms';
import { BaremePaie } from './pages/paie/BaremePaie';
import { Remunerations } from './pages/paie/Remunerations';
import { Presences } from './pages/paie/Presences';
import { MesPresences } from './pages/paie/MesPresences';
import { CalculPaie } from './pages/paie/CalculPaie';
import { CalendrierRh } from './pages/administration/Calendrier';
import { CongesListe } from './pages/rh/CongesListe';
import { CongeFormulaire } from './pages/rh/CongeFormulaire';
import { CongeDetail } from './pages/rh/CongeDetail';
import { CalendrierAbsences } from './pages/rh/CalendrierAbsences';
import { DroitsRh } from './pages/rh/DroitsRh';
import { NonPrestes } from './pages/rh/NonPrestes';
import { PretsListe } from './pages/rh/PretsListe';
import { PretNouvelle } from './pages/rh/PretNouvelle';
import { PretDossier } from './pages/rh/PretDossier';
import { Portefeuille } from './pages/rh/Portefeuille';
import { RetenuesPrets } from './pages/rh/RetenuesPrets';
import { Recouvrement } from './pages/rh/Recouvrement';
import { PretAccordePage } from './pages/rh/PretAccordePage';
import { Bibliotheque } from './pages/procedures/Bibliotheque';
import { ProcedureFiche } from './pages/procedures/ProcedureFiche';
import { SuiviProcedures } from './pages/procedures/SuiviProcedures';
import { GestionProcedures } from './pages/procedures/GestionProcedures';
import { DomainesProcedures } from './pages/administration/DomainesProcedures';
import { Bareme } from './pages/administration/Bareme';
import { DestinatairesRapports } from './pages/administration/DestinatairesRapports';
import { ServicesDirections } from './pages/administration/ServicesDirections';
import { JournalAudit } from './pages/administration/JournalAudit';
import { Parametres } from './pages/administration/Parametres';
import { UtilisateurDetail } from './pages/administration/UtilisateurDetail';
import { Utilisateurs } from './pages/administration/Utilisateurs';
import { BcDetail } from './pages/achats/BcDetail';
import { BcFormulaire } from './pages/achats/BcFormulaire';
import { BcListe } from './pages/achats/BcListe';
import { RequisitionDetail } from './pages/requisitions/RequisitionDetail';
import { RequisitionFormulaire } from './pages/requisitions/RequisitionFormulaire';
import { RequisitionListe } from './pages/requisitions/RequisitionListe';
import { CourrierDetail } from './pages/courrier/CourrierDetail';
import { CourrierFormulaire } from './pages/courrier/CourrierFormulaire';
import { CourrierListe } from './pages/courrier/CourrierListe';
import { Delegations } from './pages/courrier/Delegations';
import { FactureDetail } from './pages/courrier/FactureDetail';
import { FactureFormulaire } from './pages/courrier/FactureFormulaire';
import { FactureListe } from './pages/courrier/FactureListe';
import { InstructionDetail } from './pages/courrier/InstructionDetail';
import { InstructionsRegistre } from './pages/courrier/InstructionsRegistre';
import { Parapheur } from './pages/courrier/Parapheur';
import { FedDetail } from './pages/fed/FedDetail';
import { FedFormulaire } from './pages/fed/FedFormulaire';
import { FedListe } from './pages/fed/FedListe';
import { NoteDetail } from './pages/note/NoteDetail';
import { NoteFormulaire } from './pages/note/NoteFormulaire';
import { NoteListe } from './pages/note/NoteListe';
import { NoteNouvelle } from './pages/note/NoteNouvelle';
import { TdrDetail } from './pages/tdr/TdrDetail';
import { TdrFormulaire } from './pages/tdr/TdrFormulaire';
import { TdrListe } from './pages/tdr/TdrListe';
import { AccueilTresorerie } from './pages/tresorerie/Accueil';
import { CaisseTresorerie } from './pages/tresorerie/Caisse';
import { ComptesTresorerie } from './pages/tresorerie/Comptes';
import { DossierDetail } from './pages/tresorerie/DossierDetail';
import { DossiersListe } from './pages/tresorerie/DossiersListe';
import { OperationDetail, OperationsTresorerie } from './pages/tresorerie/Operations';
import { PlanDecaissement } from './pages/tresorerie/Plan';
import { RapportsTresorerie } from './pages/tresorerie/Rapports';
import { SituationTresorerie } from './pages/tresorerie/Situation';

export function App() {
  return (
    <Routes>
      <Route path="/connexion" element={<Connexion />} />
      <Route element={<RequireAuth />}>
        <Route element={<AppShell />}>
          <Route element={<GardeModule />}>
          <Route index element={<Navigate to="/tableau-de-bord" replace />} />
          <Route path="/tableau-de-bord" element={<TableauDeBord />} />
          <Route path="/rh" element={<MesDemarches />} />
          <Route path="/rh/agents" element={<AgentsRh />} />
          <Route path="/rh/agents/:id" element={<FicheRhPage />} />
          <Route path="/rh/agents/:id/dossier" element={<DossierHrmsPage />} />
          <Route path="/rh/mon-dossier" element={<DossierHrmsPage moi />} />
          <Route path="/rh/hrms" element={<GestionHrms />} />
          <Route path="/paie/bareme" element={<BaremePaie />} />
          <Route path="/paie/remunerations" element={<Remunerations />} />
          <Route path="/paie/presences" element={<Presences />} />
          <Route path="/rh/mes-presences" element={<MesPresences />} />
          <Route path="/paie/calculs" element={<CalculPaie />} />
          <Route path="/rh/conges" element={<CongesListe />} />
          <Route path="/rh/conges/nouvelle" element={<CongeFormulaire />} />
          <Route path="/rh/conges/droits" element={<DroitsRh />} />
          <Route path="/rh/conges/:id" element={<CongeDetail />} />
          <Route path="/rh/conges/:id/modifier" element={<CongeFormulaire />} />
          <Route path="/rh/conges/:id/nouvelle-version" element={<CongeFormulaire />} />
          <Route path="/rh/calendrier" element={<CalendrierAbsences />} />
          <Route path="/rh/non-prestes" element={<NonPrestes />} />
          <Route path="/rh/non-prestes/:mois" element={<NonPrestes />} />
          <Route path="/rh/prets" element={<PretsListe />} />
          <Route path="/rh/prets/nouvelle" element={<PretNouvelle />} />
          <Route path="/rh/prets/retenues" element={<RetenuesPrets />} />
          <Route path="/rh/prets/retenues/:mois" element={<RetenuesPrets />} />
          <Route path="/rh/prets/recouvrement" element={<Recouvrement />} />
          <Route path="/rh/prets/:id" element={<PretDossier />} />
          <Route path="/rh/portefeuille" element={<Portefeuille />} />
          <Route path="/rh/portefeuille/:id" element={<PretAccordePage />} />
          <Route path="/rh/:onglet" element={<MesDemarches />} />
          <Route path="/procedures" element={<Bibliotheque />} />
          <Route path="/procedures/suivi" element={<SuiviProcedures />} />
          <Route path="/procedures/gestion" element={<GestionProcedures />} />
          <Route path="/procedures/:id" element={<ProcedureFiche />} />
          <Route path="/tdr" element={<TdrListe />} />
          <Route path="/tdr/nouveau" element={<TdrFormulaire />} />
          <Route path="/tdr/:id" element={<TdrDetail />} />
          <Route path="/tdr/:id/modifier" element={<TdrFormulaire />} />
          <Route path="/tdr/:tdrId/note/nouvelle" element={<NoteFormulaire />} />
          <Route path="/ne" element={<NoteListe />} />
          <Route path="/ne/nouvelle" element={<NoteNouvelle />} />
          <Route path="/ne/:id" element={<NoteDetail />} />
          <Route path="/ne/:id/modifier" element={<NoteFormulaire />} />
          <Route path="/fed" element={<FedListe />} />
          <Route path="/fed/nouveau" element={<FedFormulaire />} />
          <Route path="/fed/:id" element={<FedDetail />} />
          <Route path="/fed/:id/modifier" element={<FedFormulaire />} />
          <Route path="/requisitions" element={<RequisitionListe />} />
          <Route path="/requisitions/nouvelle" element={<RequisitionFormulaire />} />
          <Route path="/requisitions/:id" element={<RequisitionDetail />} />
          <Route path="/requisitions/:id/modifier" element={<RequisitionFormulaire />} />
          <Route path="/achats" element={<BcListe />} />
          <Route path="/achats/nouveau" element={<BcFormulaire />} />
          <Route path="/achats/:id" element={<BcDetail />} />
          <Route path="/achats/:id/modifier" element={<BcFormulaire />} />
          <Route path="/budget" element={<Budget />} />
          <Route path="/budget/plan-mensuel" element={<PlanMensuel />} />
          <Route path="/budget/versions" element={<BudgetVersions />} />
          <Route path="/plan" element={<PlanListe />} />
          <Route path="/plan/:ligneId" element={<PlanFiche />} />
          <Route path="/courrier" element={<CourrierListe />} />
          <Route path="/courrier/nouveau" element={<CourrierFormulaire />} />
          <Route path="/courrier/:id" element={<CourrierDetail />} />
          <Route path="/courrier/:id/modifier" element={<CourrierFormulaire />} />
          <Route path="/factures" element={<FactureListe />} />
          <Route path="/factures/nouvelle" element={<FactureFormulaire />} />
          <Route path="/factures/:id" element={<FactureDetail />} />
          <Route path="/factures/:id/modifier" element={<FactureFormulaire />} />
          <Route path="/instructions" element={<InstructionsRegistre />} />
          <Route path="/instructions/:id" element={<InstructionDetail />} />
          <Route path="/parapheur" element={<Parapheur />} />
          <Route path="/delegations" element={<Delegations />} />
          <Route path="/tresorerie" element={<AccueilTresorerie />} />
          <Route path="/tresorerie/dossiers" element={<DossiersListe />} />
          <Route path="/tresorerie/dossiers/:id" element={<DossierDetail />} />
          <Route path="/tresorerie/plan" element={<PlanDecaissement />} />
          <Route path="/tresorerie/situation" element={<SituationTresorerie />} />
          <Route path="/tresorerie/caisse" element={<CaisseTresorerie />} />
          <Route path="/tresorerie/operations" element={<OperationsTresorerie />} />
          <Route path="/tresorerie/operations/:id" element={<OperationDetail />} />
          <Route path="/tresorerie/comptes" element={<ComptesTresorerie />} />
          <Route path="/tresorerie/rapports" element={<RapportsTresorerie />} />
          <Route path="/rapports" element={<Rapports />} />
          <Route path="/rapports/commentaires" element={<CommentairesCloture />} />
          <Route path="/ressources" element={<Ressources />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/mot-de-passe" element={<MotDePasse />} />
          <Route path="/administration" element={<Navigate to="/administration/utilisateurs" replace />} />
          <Route path="/administration/utilisateurs" element={<Utilisateurs />} />
          <Route path="/administration/utilisateurs/:id" element={<UtilisateurDetail />} />
          <Route path="/administration/bareme" element={<Bareme />} />
          <Route path="/administration/parametres" element={<Parametres />} />
          <Route path="/administration/destinataires" element={<DestinatairesRapports />} />
          <Route path="/administration/services" element={<ServicesDirections />} />
          <Route path="/administration/calendrier" element={<CalendrierRh />} />
          <Route path="/administration/audit" element={<JournalAudit />} />
          <Route path="/administration/procedures" element={<DomainesProcedures />} />
          <Route path="*" element={<Navigate to="/tableau-de-bord" replace />} />
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}
